import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Jar.svg",
  "use": "Jar.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Jar.svg\"><path d=\"M10,46V33.3137a8,8,0,0,1,2.3431-5.6568l3.3138-3.3138A8,8,0,0,1,21.3137,22H42.6863a8,8,0,0,1,5.6568,2.3431l3.3137,3.3138A7.9994,7.9994,0,0,1,54,33.3137V46a8,8,0,0,1-8,8H18A8,8,0,0,1,10,46ZM46.5,20h-29A1.5,1.5,0,0,1,16,18.5v-5A1.5,1.5,0,0,1,17.5,12h29A1.5,1.5,0,0,1,48,13.5v5A1.5,1.5,0,0,1,46.5,20Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol